import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Button, Container } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./Job.css";
import { JobCard } from "./JobCard";
import Card from "react-bootstrap/Card";
import { JobDetail } from "./JobDetail";
import {
    selectJobList,
    selectDepartment,
    selectDivisions,
    selectJobsStatus
} from "../../store/slices/job-listings-slice";
import { MdOutlineVerticalAlignTop } from "react-icons/md";
import { FaSortAlphaDown, FaSortAlphaDownAlt } from "react-icons/fa";
import { useSelector } from "react-redux";

import { selectLastSelectedJob } from "../../store/slices/last-selected-job-slice";

import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { FaSortAmountDownAlt, FaSortAmountUpAlt   } from "react-icons/fa";

// Filtering and searching default variables.
let originalJobList = [];
let departmentList = null;
let divisionList = null;

export const JobsPage = () => {
    // State that holds the jobs in view
    const [viewableJobList, setViewableJobList] = useState([]);
    // Search input state
    const [searchInput, setSearchInput] = useState("");
    // Division filter state
    const [divisionSelect, setDivisionSelect] = useState(null);
    // department filter state
    const [departmentSelect, setDepartmentSelect] = useState(null);
    // State the represents the current sort mode
    const [sortState, setSortState] = useState("ZA");

    const [width, setWidth] = useState(window.innerWidth);

    const structuredJobData = useSelector(selectJobList);
    const jobDepartments = useSelector(selectDepartment);
    const jobDivisions = useSelector(selectDivisions);
    const jobsStatus = useSelector(selectJobsStatus);

    const lastSelectedJob = useSelector(selectLastSelectedJob)
    const navigate = useNavigate();
    
    const ref = useRef(null);

    

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    const handleClick = () => {
        ref.current?.scrollIntoView({ behavior: "smooth" });
        ref.current?.focus()
    };

    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    let { jobID } = useParams();


    // If there is a selected job, go to it on mobile
    useEffect(() => {
        if(isMobile && lastSelectedJob) {
            navigate(lastSelectedJob)
        }
    },[])


      // Compare function that returns true if 'a' > 'b', sorts A...Z
    const compareOpen = (a, b) => {
        // console.log(a)
        let res = new Date(b.dateOpen) - new Date(a.dateOpen);
        return res;
    };
    // Hook that reads in the jobs from the jvs.xlsx and loads them into their states.
    // When the website first loads
    useEffect(() => {
        // On initial load
        const fetchData = async () => {
            // Set the original unaltered job list to a variable
            originalJobList = structuredJobData;
            const arr = [...originalJobList].sort(compareLatest)
            
            // Set the viewable job list as the original list
            setViewableJobList(arr);

            // Remove the duplicates in jobDepartment array
            departmentList = [...new Set(jobDepartments)];
            // Remove the duplicates in jobDivision array
            divisionList = [...new Set(jobDivisions)];

            // Sort the department list
            departmentList.sort();

            // Sort the division list
            divisionList.sort();
        };

        // Load the jobs, division, departments into arrays
        if (jobsStatus === "succeeded") {
            fetchData();
        }
    }, [jobsStatus, jobDepartments, jobDivisions, structuredJobData]);

    /**
     * Hook that watches the searchbar, division dropdown and  department dropdown and filters
     * the current viewable job list
     */
    useEffect(() => {
        // list of jobs that fit the filtering results
        let filteredList = [];

        // Loop through the original job list and filter it based on the search value
        for (const currentJob of originalJobList) {
            // Extract all the values from the current job, currentJob
            const {
                positionTitle,
                reqID,
                positionNumber,
                location,
                division,
                department
            } = currentJob;

            // If search bar is empty, filter off"
            // 1. the department selected in the dropdown
            // 2. the division selected in the dropdown
            if (searchInput === "") {
                // If search result is empty, add the current job. No need to filter
                if (departmentSelect === null && divisionSelect === null) {
                    filteredList.push(currentJob);
                } else {
                    // If a department is not selected in the dropdown,
                    // filter job based on division selected in dropdown
                    if (
                        departmentSelect === null &&
                        division.includes(divisionSelect)
                    ) {
                        filteredList.push(currentJob);
                        // If a division is not selected in the dropdown,
                        // filter job based on department selected in dropdown
                    } else if (
                        divisionSelect === null &&
                        department.includes(departmentSelect)
                    ) {
                        filteredList.push(currentJob);
                    } else if (
                        //If a division and department are selected:
                        // filter job based on division AND department
                        division.includes(divisionSelect) &&
                        department.includes(departmentSelect)
                    ) {
                        filteredList.push(currentJob);
                    }
                }
                // Search bar is NOT empty
            } else {
                // Check search bar value with job title, reqID, position number and location and store result in searchMatches
                let searchMatches =
                    positionTitle
                        .toLowerCase()
                        .includes(searchInput.toLowerCase()) ||
                    location
                        .toLowerCase()
                        .includes(searchInput.toLowerCase()) ||
                    positionNumber
                        .toLowerCase()
                        .startsWith(searchInput.toLowerCase()) ||
                    reqID.toLowerCase().startsWith(searchInput.toLowerCase());
                // IF department AND division are NOT selected in dropdown menus:
                // Filter based off search bar only
                if (
                    departmentSelect === null &&
                    divisionSelect === null &&
                    searchMatches
                ) {
                    filteredList.push(currentJob);
                    // If department is NOT select but division is:
                    // Filter based off selected division AND search bar
                } else if (
                    departmentSelect === null &&
                    division.includes(divisionSelect) &&
                    searchMatches
                ) {
                    filteredList.push(currentJob);
                    // If division is NOT select but department is:
                    // Filter based off selected division AND search bar
                } else if (
                    divisionSelect === null &&
                    department.includes(departmentSelect) &&
                    searchMatches
                ) {
                    filteredList.push(currentJob);
                    // If the division AND department are selected:
                    // Filter based off selected division, selected department AND search bar
                } else if (
                    searchMatches &&
                    division.includes(divisionSelect) &&
                    department.includes(departmentSelect)
                ) {
                    filteredList.push(currentJob);
                }
            }

            // Set the viewable jobs as the resulting filtered list
            setViewableJobList(filteredList);
        }
        // Call this hook when departmentSelect, divisionSelect and searchInput are changed
    }, [departmentSelect, divisionSelect, searchInput]);

    const compareLatest = (a, b) => {
        let res = new Date(b.dateOpen) - new Date(a.dateOpen);
        return res;
    }

    const compareOldest = (a, b) => {
        let res = new Date(a.dateOpen) - new Date(b.dateOpen);
        return res;
    }

    // custom comapre to sort with
    // const compareLatest = (a, b) => {
    //     let aJobReqID = a.reqID;
    //     let bJobReqID = b.reqID;

    //     const alphaRegex = /[A-Z]+/; // get first letters

    //     const aLetters = aJobReqID.match(alphaRegex).toString(); // get first letters in job reqID a
    //     const bLetters = bJobReqID.match(alphaRegex).toString(); // get first letters in job reqID b

    //     // //  Compare the first letters i.e., "a" > "b" === true (not literal)

    //     let res = aLetters.localeCompare(bLetters); // better than >,<,= compare jobs displayed in accorddance with departments dropdown menu

    //     // a: DCD > b: DODE
    //     if (res == 1) {
    //         return res;
    //     }
    //     // a: DODC < b: DCD
    //     if (res == -1) {
    //         return res;
    //     }

    //     // First letters in job reqID a AND job reqID b are the same
    //     // Compare the trailing numbers AFTER the letters
    //     // [A-Z]...+[0-9]...

    //     const numRegex = /\d+/; // get the trailing numbers
    //     const aNum = parseInt(aJobReqID.match(numRegex), 10); // get the traling numbers in job reqID a
    //     const bNum = parseInt(bJobReqID.match(numRegex), 10); // get the trailing numbers in job reqID b

    //     //  Compare the trailing numbers
    //     if (aNum < bNum) {
    //         return 1;
    //     }

    //     if (aNum > bNum) {
    //         return -1;
    //     }

    //     return 0; // job reqID a === job reqID b
    // };

    //Function that sorts the viewable job list and updated the sort state to Z...A
    const sortJobsAtoZ = () => {
        const arr = [...viewableJobList].sort(compareLatest)
        setViewableJobList(arr)
        setSortState("ZA");
    };

    //Function that sorts the viewable job list and updated the sort state to A...Z
    const sortJobsZtoA = () => {
        const arr = [...viewableJobList].sort(compareOldest)
        setViewableJobList(arr)
        setSortState("AZ");
    };


    /**
     * Function that resets the viewable job list as the original list and resets the search bar text
     */
    const resetFilter = () => {
        setViewableJobList(originalJobList);
        setSearchInput("");
        setDepartmentSelect(null);
        setDivisionSelect(null);
        setSortState("ZA");
    };

    /**
     *  Function that gets a division and sets it as the selected division.
     * @param {State} division
     */
    const clickDivision = (division) => {
        setDivisionSelect(division);
    };

    /**
     * Function that gets a department and sets it as the selected division.
     * @param {State} department
     */
    const clickDepartment = (department) => {
        setDepartmentSelect(department);
    };

    /**
     * Function that updates the value in the searchbar
     * @param {event} event, the value in the searchbar
     */
    const onInput = (event) => {
        setSearchInput(event.target.value);
    };

    return (
        <Row className="justify-content-center">
            <Col xs={12} md={11}>
                <Row className="justify-content-center card-background rounded-3 shadow-sm py-2 my-2">
                    <Row>
                        <Col className="text-center" xs={12}>
                            <h1>Job Search</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={10} className="col-md-9 mb-md-2">
                            <label
                                htmlFor="searchInput"
                                className="form-label visually-hidden"
                            >
                                Search Positions
                            </label>
                            <div className="input-group mb-2">
                                <input
                                    autoFocus
                                    type="text"
                                    className="form-control"
                                    id="searchInput"
                                    placeholder="Search by Position, Location, Position Number or Requisition ID"
                                    aria-label="Search Positions"
                                    aria-describedby="Search Position by title, location, position Number or requisition ID"
                                    onChange={onInput}
                                    value={searchInput}
                                />
                            </div>
                        </Col>
                        <Col lg={2} className="mb-3 col-md-3">
                            <button
                                id="resetFilterButton"
                                className="btn btn-secondary dropdown-filter col-12"
                                type="button"
                                onClick={resetFilter}
                                aria-label="Reset search bar and filters"
                            >
                                Reset Search
                            </button>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="5" className="col-md-6 mb-3">
                            <div id="divisionDropdownMenu" className="dropdown">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="divisionDropdownButton"
                                        className="btn btn-secondary dropdown-toggle dropdown-filter"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="Filter by Division"
                                    >
                                        {divisionSelect
                                            ? divisionSelect
                                            : "Filter by Division"}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="dropdown-list">
                                        {divisionList &&
                                            divisionList.map((item, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() =>
                                                            clickDivision(item)
                                                        }
                                                    >
                                                        {item}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Col>
                        <Col lg="5" className="col-md-6 mb-3">
                            <div id="departmentDropdownMenu" className="dropdown">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="departmentDropdownButton"
                                        className="btn btn-secondary dropdown-toggle dropdown-filter"
                                        type="button"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        aria-label="Filter by department"
                                    >
                                        {departmentSelect
                                            ? departmentSelect
                                            : "Filter by Department"}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="dropdown-list">
                                        {departmentList &&
                                            departmentList.map((item, index) => {
                                                return (
                                                    <Dropdown.Item
                                                        key={index}
                                                        onClick={() =>
                                                            clickDepartment(item)
                                                        }
                                                    >
                                                        {item}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Col>
                        <Col className="text-center">
                            <h3  style={{ marginLeft: "0" }}>
                                
                                {sortState === "ZA" && (
                                    <>
                                        <Button
                                        onClick={sortJobsZtoA}
                                        aria-label= {"Sort Jobs A to Z" }
                                        className="btn btn-secondary">
                                            Sort By Recent Jobs&nbsp;
                                            <FaSortAmountDownAlt onClick={sortJobsZtoA} />
                                        </Button>
                                    </>
                                )}
                                {sortState === "AZ" && (
                                    <>
                                        <Button
                                        onClick={sortJobsAtoZ}
                                        aria-label= { "Sort Jobs Z to A"}
                                        className="btn btn-secondary">
                                            Sort By Oldest Jobs&nbsp;
                                            <FaSortAmountUpAlt   onClick={sortJobsAtoZ} />
                                        </Button>
                                    </>
                                )}
                                {/* <Button
                                    aria-label= {sortState === "ZA" ? "Sort Jobs A to Z" :  "Sort Jobs Z to A"}
                                    className="btn btn-secondary">
                                    
                                {sortState === "AZ" ? (
                                    <FaSortAlphaDownAlt onClick={sortJobsAtoZ} />
                                ) : (
                                    <FaSortAlphaDown onClick={sortJobsZtoA} />
                                )}
                                </Button> */}
                            </h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p><a className="list-link" target="_blank" rel="noopener noreferrer" href="https://www.dpm.navajo-nsn.gov/pages/jobs/navajo-nation-job-listing.pdf"><b>Click here</b></a> to view list of jobs in PDF</p>
                        </Col>
                    </Row>

                    {!isMobile && (
                        <Row lg={12}>
                            <Col md={4}>
                                <div className="jobList overflow-auto">
                                    {viewableJobList.length !== 0 && viewableJobList.map((item, index) => {
                                        return (
                                            <Link
                                                style={{ textDecoration: "none" }}
                                                key={index}
                                                to={"/jobs/" + item.reqID}
                                                
                                            >
                                                <JobCard props={item} index={index + 1} />
                                            </Link>
                                        );
                                    })}
                                    {viewableJobList.length === 0 && (
                                         <>
                                            <Container className="bg-dark-subtle bg-opacity-25  rounded-5 border-shadow">
                                                <Row>
                                                    <Card>
                                                        <Card.Body>
                                                            <Card.Title>
                                                                <b role="status" className="border-bottom border-warning border-3">
                                                                    No Jobs Found.
                                                                </b>
                                                            </Card.Title>
                                                        </Card.Body>
                                                    </Card>
                                                </Row>
                                            </Container>
                                        </>
                                    )}
                                </div>
                            </Col>
                            <Col className="selectedJob">
                                <div>
                                    <JobDetail />
                                </div>
                            </Col>
                        </Row>
                    )}
                    {isMobile && !jobID && (
                        <>
                            <Row lg={12}>
                                <Col lg={4}>
                                    <div className="scrollToTop">
                                        <button
                                            aria-label="Scroll to the First job"
                                            className="scroll-top-button cursor-pointer p-2 rounded"
                                            onClick={() => handleClick()}
                                        >
                                            <MdOutlineVerticalAlignTop size={35} />
                                        </button>
                                    </div>
                                    <div className="jobList overflow-auto">
                                        {viewableJobList.length !== 0 && viewableJobList.map((item, index) => {
                                            if (index === 0) {
                                                return (
                                                    <Link
                                                        style={{
                                                            textDecoration: "none"
                                                        }}
                                                        key={index}
                                                        to={"/jobs/" + item.reqID}
                                                        ref={ref}
                                                    >
                                                        <JobCard props={item} index={index + 1}/>
                                                    </Link>
                                                );
                                            } else {
                                                return (
                                                    <Link
                                                        style={{
                                                            textDecoration: "none"
                                                        }}
                                                        key={index}
                                                        to={"/jobs/" + item.reqID}
                                                    >
                                                        <JobCard props={item} index={index + 1}/>
                                                    </Link>
                                                );
                                            }
                                        })}
                                        {viewableJobList.length === 0 && (
                                            <>
                                                <Container className="bg-dark-subtle bg-opacity-25  rounded-5 border-shadow">
                                                    <Row>
                                                        <Card>
                                                            <Card.Body>
                                                                <Card.Title>
                                                                    <b role="status" className="border-bottom border-warning border-3">
                                                                        No Jobs Found.
                                                                    </b>
                                                                </Card.Title>
                                                            </Card.Body>
                                                        </Card>
                                                    </Row>
                                                </Container>
                                            </>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </>
                    )}
                    {isMobile && jobID && (
                        <Row lg={12}>
                            <Col>
                                <div className="selectedJob">
                                    <JobDetail mobileView={isMobile} />
                                </div>
                            </Col>
                        </Row>
                    )}
                </Row>
            </Col>
        </Row>

    );
};
